export default __webpack_public_path__ + "static/media/portal.3cc2260c.svg";